import { actionGenerator } from '../../utils/redux/actionGenerator';
import {
  EOffersFromHistoryActionTypes,
  IOffersFromHistoryPayload,
  IOffersFromHistoryToggleFavoritePayload,
} from './types';

export const setOffersFromHistory = actionGenerator<EOffersFromHistoryActionTypes.Set, IOffersFromHistoryPayload>(
  EOffersFromHistoryActionTypes.Set,
);

export const toggleFavoriteOffersFromHistory = actionGenerator<
  EOffersFromHistoryActionTypes.ToggleFavorite,
  IOffersFromHistoryToggleFavoritePayload
>(EOffersFromHistoryActionTypes.ToggleFavorite);
